import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"


@Injectable({
    providedIn: 'root'
})
export class AccountApiService {

    constructor(
        private http: HttpClient
    ) { }

    public getUserSettings() {
        return this.http.post(API_HOST + 'account/settings', {})
    }

    public updatePersonalInformations(data: any) {
        return this.http.post(API_HOST + 'account/update-personal-informations', data)
    }

    public updateCompanyData(data: any) {
        return this.http.post(API_HOST + 'account/update-company-data', data)
    }

    public completeRegister(data: any) {
        return this.http.post(API_HOST + 'account/complete-register', data)
    }

    public checkNipAvailability(nip: string) {
        return this.http.get<{ success: boolean; data?: { available: boolean }; message?: string }>(
            API_HOST + 'account/check-nip/' + nip
        )
    }

    public deleteAccount() {
        return this.http.delete(API_HOST + 'account')
    }

    /**
     * Company logo
     */
    public setCompanyLogo(formData) {
        return this.http.post<any>(API_HOST + 'account/company/logo', formData);
    }

    public deleteCompanyLogo() {
        return this.http.delete<any>(API_HOST + 'account/company/logo');
    }
}